import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ns-floating-footer',
    templateUrl: './floating-footer.component.html',
    styleUrls: ['./floating-footer.component.scss']
})
export class FloatingFooterComponent implements OnInit {

    @Output() backClick: EventEmitter<any> = new EventEmitter<any>();
    @Output() mainClick: EventEmitter<any> = new EventEmitter<any>();

    @Input() backButtonText: string = 'Powrót';
    @Input() mainButtonText: string = 'Dalej';

    @Input() mainButtonDisabled = false;

    constructor() { }

    ngOnInit(): void {
    }

    onMainClick() {
        this.mainClick.emit();
    }
    onBackClick() {
        this.backClick.emit();
    }

}
